import styled from "styled-components";
import {
  Alert,
  Checkbox,
  Col,
  Empty,
  Pagination,
  Row,
  Spin,
  Tag,
  Typography,
} from "antd";
import AppTable from "./AppTable";
import AppTableContainer from "../../AppComponents/AppTableContainer";
import AppCard from "@lib/components/AppComponents/AppCard";
import { getContrastColor } from "@lib/helpers/ColorHelper";

const { Text } = Typography;

export const StyledPagination = styled(Pagination)`
  display: contents;
  & .ant-pagination-item-link,
  & .ant-pagination-item > a {
    background-color: ${({ theme }) => theme.palette.background.paper};
    color: ${({ theme }) => theme.palette.text.primary};
  }
`;

export const StyledFlex = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;

  &.actions {
    justify-content: center;
    gap: 5px;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-right: 10px;

  [dir="rtl"] & {
    margin-right: 0;
    margin-left: 10px;
  }
`;

export const StyledMinimalTable = styled(AppTable)`
  & .ant-table-thead > tr > th {
    border-bottom: 0 none;
    font-size: 13px;
    padding: 8px;
    font-weight: ${({ theme }) => theme.font.weight.bold};
    background-color: transparent;
    color: ${({ theme }) => theme.palette.text.primary};

    &:first-child {
      padding-left: 20px;

      [dir="rtl"] & {
        padding-left: 0;
        padding-right: 20px;
      }
    }

    &:last-child {
      padding-right: 20px;

      [dir="rtl"] & {
        padding-right: 0;
        padding-left: 20px;
      }
    }
  }

  & .ant-table-tbody > tr > td {
    border-bottom: 0 none;
    font-size: 13px;
    padding: 6px 8px;

    &:first-child {
      padding-left: 20px;

      [dir="rtl"] & {
        padding-left: 0;
        padding-right: 20px;
      }
    }

    &:last-child {
      padding-right: 20px;

      [dir="rtl"] & {
        padding-right: 0;
        padding-left: 20px;
      }
    }
  }
`;

export const StyledHoverTable = styled(AppTableContainer)`
  & .ant-table-thead > tr > th {
    font-size: 13px;
    padding: 8px;
    font-weight: ${({ theme }) => theme.font.weight.bold};
    background-color: transparent;

    &:first-child {
      padding-left: 20px;

      [dir="rtl"] & {
        padding-left: 0;
        padding-right: 20px;
      }
    }

    &:last-child {
      padding-right: 20px;

      [dir="rtl"] & {
        padding-right: 0;
        padding-left: 20px;
      }
    }

    &.order-table-action {
      text-align: center;
      background-color: ${({ theme }) =>
        theme.palette.background.paper} !important;
    }
  }

  & .ant-table-tbody > tr > td {
    font-size: 13px;
    padding: 12px 8px;

    &:first-child {
      padding-left: 20px;

      [dir="rtl"] & {
        padding-left: 0;
        padding-right: 20px;
      }
    }

    &:last-child {
      padding-right: 20px;

      [dir="rtl"] & {
        padding-right: 0;
        padding-left: 20px;
      }
    }

    &.order-table-action {
      text-align: center;
      background-color: ${({ theme }) =>
        theme.palette.background.paper} !important;
    }
  }

  & .badge {
    padding: 3px 10px;
    border-radius: ${({ theme }) => theme.cardRadius};
    display: inline-block;
  }
`;

export const StyledTableInfoAlert = styled(Alert)`
  width: 100% !important;
  padding: 0px 10px;
`;

export const StyledTableHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 3px;
`;

export const StyledTableHeaderItem = styled.div<{ mobile?: boolean }>`
  display: flex;
  width: 100%;
  gap: 15px;
  flex-direction: ${({ mobile }) => (mobile ? "column" : "row")};
`;

export const StyledTableHeaderInfo = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

export const StyledTableHeaderPagination = styled.div<{ mobile?: boolean }>`
  display: flex;
  margin-left: 10px;
  flex-direction: ${({ mobile }) => (mobile ? "column" : "row")};
`;

//
//
// mobile table
export const StyledMobileTable = styled.div`
  // max-height: 80vh;
  width: 100%;
  overflow-y: auto;
`;

export const StyledMobileTableEmpty = styled(Empty)`
  padding: 50px;
`;

export const StyledMobileTableCard = styled(AppCard)<{ $striped?: boolean }>`
  margin-bottom: 5px;
  border-radius: 8px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 2px solid ${({ theme }) => theme.palette.borderColor};
  background-color: ${({ theme, $striped }) =>
    $striped
      ? theme.palette.background.secondary
      : theme.palette.background.default} !important;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
`;

export const StyledMobileTableRow = styled(Row)`
  margin-bottom: 5px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
  &:last-child {
    border-bottom: none;
  }
`;

export const StyledMobileTableCol = styled(Col)`
  display: flex;
  align-items: center;
`;

export const StyledMobileTableLabelText = styled(Text)`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  letter-spacing: 0.5px;
`;

export const StyledMobileTableValueText = styled(Text)`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const StyledMobileTableSpinDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.2);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledMobileTableSpin = styled(Spin)``;

export const StyledTableFilterTag = styled(Tag)`
  color: ${({ color }) => getContrastColor(color)} !important;
  background-color: ${({ color }) => color} !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;

  span,
  small,
  .ant-typography {
    color: ${({ color }) => getContrastColor(color)} !important;
    font-size: 10px !important;
    padding: 0 !important;
    margin: 0 !important;
    line-height: 1 !important;
  }
`;

// Mobile table filters
export const StyledMobileTableFiltersContainer = styled.div`
  width: 100%;
  border-radius: 8px;
`;

export const StyledMobileTableFiltersRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
`;

export const StyledMobileTableFiltersTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
  overflow-x: auto;
  min-width: 0;
`;
